import Shelf, { type ShelfProps } from 'components/containers/shelf';
import PageSection, {
	type PageSectionProps,
} from 'components/containers/page-section';

const ShelfSection = ({
	children,
	autoSizeItems,
	autoSizedVisibleItemCount,
	hasClampedWidth = false,
	...restProps
}: IProps) => {
	return (
		<PageSection {...restProps} hasClampedWidth={hasClampedWidth}>
			<Shelf
				autoSizeItems={autoSizeItems}
				autoSizedVisibleItemCount={autoSizedVisibleItemCount}
				hasClampedWidth={hasClampedWidth}
			>
				{children}
			</Shelf>
		</PageSection>
	);
};

interface IProps extends PageSectionProps {
	autoSizeItems?: ShelfProps['autoSizeItems'];
	autoSizedVisibleItemCount?: ShelfProps['autoSizedVisibleItemCount'];
}

export default ShelfSection;
